export enum KindBoard {
  Tarefa = 0,
  Insumo = 1
}

export enum ContextCockpit {
  Padrao = 0,
  RM = 1,
  PortalDaObra = 2
}
